<div
  class="token-logo-wrapper flex overflow-hidden {{ size() }} skeleton"
  [class.is-loading]="isLoading()"
>
  <div
    [style.background-image]="imageURL() ? 'url(' + imageURL() + ')' : null"
  ></div>
</div>
